import {initialState as auth} from "../reducers/auth";
import {initialState as utils} from "../reducers/utils";
import {initialState as languages} from "../reducers/languages";
import {initialState as moderators} from "../reducers/moderators";
import {initialState as staticTexts} from "../reducers/staticTexts";
import {initialState as media} from "../reducers/media";
import {initialState as composite} from "../reducers/composite";
import {initialState as slider} from "../reducers/slider";
import {initialState as banner} from "../reducers/banner";
import {initialState as customPages} from "../reducers/customPages";
import {initialState as general} from "../reducers/general";
import {initialState as about} from "../reducers/about";
import {initialState as blogs} from "../reducers/blogs";
import {initialState as subscribers} from "../reducers/subscribers";
import {initialState as menu} from "../reducers/menu";
import {initialState as advertisement} from "../reducers/advertisement";


const reducers = {
    auth,
    utils,
    languages,
    moderators,
    staticTexts,
    media,
    composite,
    slider,
    banner,
    customPages,
    general,
    about,
    blogs,
    subscribers,
    menu,
    advertisement,
};

export default state => {
    const sData = {};
    Object.keys(reducers).forEach(selectorKey => {
        Object.keys(reducers[selectorKey]).forEach(key => {
            sData[key] = state[selectorKey][key];
        });
    });
    return sData;
};

